import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import ChallengeDetailsPage from "src/components/events/challenge/challengeDetails";
import { RODEO_PAGE_NAME, APPLICATION_NAME } from "src/_config";

export default function ChallengeDetailsContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Challenge`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.EVENT_GAME_LIST} />
        <ChallengeDetailsPage />
      </section>
    </React.Fragment>
  );
}
